const partnerPageMixin = (pageTitle, apiGroup, imgPrefix) => ({
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('components.main.navigation.partner.with.us.airalo-partner-hub'),
          link: '/partner-with-us/airalo-partner-hub',
        },
        {
          title: this.$t(pageTitle),
        },
      ],
      contents: [],
    }
  },

  async fetch() {
    try {
      const contentsData = await this.$store.dispatch('fetch_contents_group', apiGroup)

      if (contentsData) {
        this.contents = contentsData.map((v, i) => ({
          reverse: i % 2 === 0,
          img: `/assets/images/partner-with-us/${imgPrefix}-${i + 1}.png`,
          ...v,
        }))
      }
    } catch (err) {}
  },
})

export default partnerPageMixin
